import React from 'react';
import { Menu as MuiMenu, MenuItem as MuiMenuItem } from '@mui/material';
import { acmeMenuPaperSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

export function Menu({ PaperProps, children, ...props }) {
  return (
    <MuiMenu
      PaperProps={{
        ...PaperProps,
        sx: mergeSx(acmeMenuPaperSx, PaperProps?.sx),
      }}
      {...props}
    >
      {children}
    </MuiMenu>
  );
}

export function MenuItem({ sx, children, ...props }) {
  return (
    <MuiMenuItem sx={mergeSx(sx)} {...props}>
      {children}
    </MuiMenuItem>
  );
}

Menu.Item = MenuItem;

export default Menu;
